import { EmployeeTimeOffResponseDto, GetEmployeeFilesRequest, GetEmployeeProfileDto, GetEmployeeReportsFilesDto, GetEmployeFilesResponse, GetFilesByUploaderAndUserRequest, GetFilesByUploaderAndUserResponse, GetSharedFileResponseDto, GetUserFilesSharedWithViewerReq, PaginationDto, UpdateContactAndTimezoneRequest, UpdateAddressRequest, UploadEmployeeFileResponse, EmployeeAboutMeRequest, GetAboutMeResponse } from "../../interfaces/Employee/Employee";
import { ApiResponse } from "../../interfaces/genericResponse/GenericResponse";
import { apiGet, apiPut } from "../../utilities/api-client/apiRequest";

export async function UploadEmployeeFileAsync(
    file: File,
    DocumentCategoryId: number,
    authToken: string
): Promise<ApiResponse<UploadEmployeeFileResponse>> {
    try {
        const apiUrl: string = `${process.env.REACT_APP_API_BASE_URL}/employee/upload-employee-file`;

        const formData = new FormData();
        formData.append("file", file);
        formData.append("documentCategoryId", DocumentCategoryId.toString());
        const response = await fetch(apiUrl, {
            method: "POST",
            body: formData,
            headers: {
                Authorization: `Bearer ${authToken}`,
            },
        });

        if (response.ok) {
            const responseBody = await response.json();
            return responseBody;
        } else {
            const responseBody = await response.json();
            return responseBody;
        }
    } catch (error) {
        throw new Error(`Failed to upload file: ${error instanceof Error ? error.message : String(error)}`);
    }
}

export async function GetEmployeeFileAsync(
    authToken: string,
    payload: GetEmployeeFilesRequest
): Promise<ApiResponse<GetEmployeFilesResponse[]>> {
    try {
        const apiUrl: string = `${process.env.REACT_APP_API_BASE_URL}/employee/get-employee-files`;

        const response = await fetch(apiUrl, {
            method: "POST",
            headers: {
                Authorization: `Bearer ${authToken}`,
                "Content-Type": "application/json"
            },
            body: JSON.stringify(payload)
        });

        if (response.ok) {
            const responseBody = await response.json();
            return responseBody;
        } else {
            const responseBody = await response.json();
            return responseBody;
        }
    } catch (error) {
        throw new Error(`Failed to upload file: ${error instanceof Error ? error.message : String(error)}`);
    }
}


export async function GetEmployeeFileDownloadByIdAsync(
    fileId: string,
    authToken: string
): Promise<string | null> {
    const apiUrl: string = `${process.env.REACT_APP_API_BASE_URL}/employee/employeefile/download/${fileId}`;

    try {
        const response = await fetch(apiUrl, {
            method: "GET",
            headers: {
                Authorization: `Bearer ${authToken}`,
            },
        });

        const blob = await response.blob();
        return URL.createObjectURL(blob);
    } catch (err) {
        console.error("Error fetching files:", err);
        return null;
    }
}



export async function GetEmployeeProfileDetailsAsync(
    authToken: string,
    userId: string
): Promise<ApiResponse<GetEmployeeProfileDto>> {
    try {
        const apiUrl: string = `${process.env.REACT_APP_API_BASE_URL}/employee/getProfile/${userId}`;

        const response = await fetch(apiUrl, {
            method: "GET",
            headers: {
                Authorization: `Bearer ${authToken}`,
            },
        });

        if (response.ok) {
            const responseBody = await response.json();
            return responseBody;
        } else {
            const responseBody = await response.json();
            return responseBody;
        }
    } catch (error) {
        throw new Error(`Failed to upload file: ${error instanceof Error ? error.message : String(error)}`);
    }
}

interface ApiErrorResponse {
    error: string;
    details?: any;
}
export async function getUpcomingTimeOffs(userId: string, idToken: string): Promise<ApiResponse<EmployeeTimeOffResponseDto[]>> {
    const apiUrl = `${process.env.REACT_APP_API_BASE_URL}/TimeOff/get-timeOffs-for-user-profile/${userId}`;

    console.log("Fetching upcoming time offs...");

    try {
        const response = await fetch(apiUrl, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${idToken}`,
                'Content-Type': 'application/json',
            },
        });

        if (!response.ok) {
            const errorBody = await response.json();
            throw {
                status: response.status,
                message: `API request failed with status ${response.status}`,
                details: errorBody,
            };
        }

        const result = await response.json();
        return result; // Return only the list of time offs
    } catch (error: any) {
        console.error("Error fetching upcoming time offs:", error);
        throw error;
    }
}


export async function GetEmployeeReportsFiles(
    authToken: string,
    userId: string,
    pageNumber: number = 1,
    pageSize: number = 10
): Promise<ApiResponse<GetFilesByUploaderAndUserResponse>> {
    try {
        const apiUrl: string = `${process.env.REACT_APP_API_BASE_URL}/employee/files`;

        const payload: GetFilesByUploaderAndUserRequest = {
            userId: userId,
            pageNumber: pageNumber,
            pageSize: pageSize
        }

        const response = await fetch(apiUrl, {
            method: "POST",
            headers: {
                Authorization: `Bearer ${authToken}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload)
        });

        const responseBody = await response.json();
        return responseBody;
    } catch (error) {
        throw new Error(`Failed to upload file: ${error instanceof Error ? error.message : String(error)}`);
    }
}

export async function GetSharedWithMeFilesAsync(
    authToken: string,
    userId: string,
    pageNumber: number = 1,
    pageSize: number = 10,
    searchTearm: string = "",
    sortBy?: string,
    sortDirection?: string,
): Promise<ApiResponse<GetSharedFileResponseDto>> {
    try {
        const apiUrl: string = `${process.env.REACT_APP_API_BASE_URL}/employee/${userId}/shared-with`;

        const payload: GetUserFilesSharedWithViewerReq = {
            pageNumber: pageNumber,
            pageSize: pageSize,
            searchTerm: searchTearm,
            sortBy: sortBy || null,
            sortDirection: sortDirection || null
        }

        const response = await fetch(apiUrl, {
            method: "POST",
            headers: {
                Authorization: `Bearer ${authToken}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload)
        });

        const responseBody = await response.json();
        return responseBody;
    } catch (error) {
        throw error;
    }
}


export async function UpdateContactAndTimezoneAsync(
    authToken: string,
    userId: string,
    payload: UpdateContactAndTimezoneRequest
): Promise<ApiResponse<string>> {
    const apiUrl: string = `/Authentication/${userId}/UpdateContactAndTimezone`;

    var res = apiPut<ApiResponse<string>, UpdateContactAndTimezoneRequest>(
        apiUrl, payload, authToken
    );

    return res;
}

export async function UpdateUserAddressAsync(
    authToken: string,
    payload: UpdateAddressRequest
): Promise<ApiResponse<boolean>> {
    try {
        const apiUrl: string = `${process.env.REACT_APP_API_BASE_URL}/employee/update-address`;

        const response = await fetch(apiUrl, {
            method: "PUT",
            headers: {
                Authorization: `Bearer ${authToken}`,
                "Content-Type": "application/json",
            },
            body: JSON.stringify(payload),
        });

        if (response.ok) {
            const responseBody = await response.json();
            return responseBody;
        } else {
            const responseBody = await response.json();
            return responseBody;
        }
    } catch (error) {
        throw new Error(`Failed to update address: ${error instanceof Error ? error.message : String(error)}`);
    }
}


export async function GetLastProfileChangeStatusAsync(
    authToken: string,
    userId: string,
    participantId : number
): Promise<ApiResponse<boolean>> {
    const apiUrl: string = `/employee/${userId}/${participantId}/profile-change/last/is-Pending`;

    var res = apiGet<ApiResponse<boolean>>(
        apiUrl, authToken
    );

    return res;
}



export async function GetAboutMeAsync(
    authToken: string,
    employeeId: string
): Promise<ApiResponse<GetAboutMeResponse>> {
    try {
        const apiUrl: string = `${process.env.REACT_APP_API_BASE_URL}/employee/${employeeId}/aboutme`;

        const response = await fetch(apiUrl, {
            method: "GET",
            headers: {
                Authorization: `Bearer ${authToken}`,
                "Content-Type": "application/json",
            },
        });

        const responseBody = await response.json();
        return responseBody;
    } catch (error) {
        throw new Error(`Failed to get about me: ${error instanceof Error ? error.message : String(error)}`);
    }
}

export async function UpdateAboutMeAsync(
    authToken: string,
    employeeId: string,
    payload: EmployeeAboutMeRequest
): Promise<ApiResponse<string>> {
    try {
        const apiUrl: string = `${process.env.REACT_APP_API_BASE_URL}/employee/${employeeId}/aboutme`;

        // Convert camelCase to PascalCase to match C# API
        const apiPayload = {
            FunFact: payload.funFact || null,
            PassionateAbout: payload.passionateAbout || null,
            LanguagesSpoken: payload.languagesSpoken || null,
            HasPet: payload.hasPet || null,
            ListenTo: payload.listenTo || null,
            FavoriteAppFunction: payload.favoriteAppFunction || null,
        };

        const response = await fetch(apiUrl, {
            method: "PUT",
            headers: {
                Authorization: `Bearer ${authToken}`,
                "Content-Type": "application/json",
            },
            body: JSON.stringify(apiPayload),
        });

        if (response.ok) {
            const responseBody = await response.json();
            return responseBody;
        } else {
            const responseBody = await response.json();
            return responseBody;
        }
    } catch (error) {
        throw new Error(`Failed to update about me: ${error instanceof Error ? error.message : String(error)}`);
    }
}